/** A rule between two groups, optionally with a word sitting in it. */

import type { CSSProperties } from "react";

import { cn } from "@/lib/cn";

import "./Separator.css";

export interface SeparatorProps {
  readonly orientation?: "horizontal" | "vertical";
  readonly label?: string;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function Separator({ orientation = "horizontal", label, className, style }: SeparatorProps) {
  if (label !== undefined && orientation === "horizontal") {
    return (
      <div
        role="separator"
        aria-orientation="horizontal"
        className={cn("al-separator", "al-separator-labelled", className)}
        style={style}
      >
        <span className="al-separator-line" />
        <span className="al-separator-label">{label}</span>
        <span className="al-separator-line" />
      </div>
    );
  }
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn("al-separator", `al-separator-${orientation}`, className)}
      style={style}
    />
  );
}
